import { render } from "./SectionSplit.vue?vue&type=template&id=09281929"
import script from "./SectionSplit.vue?vue&type=script&lang=js"
export * from "./SectionSplit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__